export default __webpack_public_path__ + "static/media/star-emoji.38aae705.png";